<template>
	<div>
		<div class="modal fade" id="mdconsultarcliente" tabindex="-1" role="dialog">
			<div class="modal-dialog modal-xl modal-dialog-centered" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title"><i class="fa fa-search"></i> Consulta de clientes</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div id="dvconsulta" class="row">
						<div class="col-sm-12 col-md-2 col-lg-2">
							<label for="cbopfiltrocc">Filtrar:</label>
							<select name="cbopfiltrocc" class="form-control form-control-sm" id="cbopfiltrocc" v-model="pfiltrocc">
                                    <option value="0">Código</option>
                                    <option value="1">Nome/Razão Social</option>
                                    <option value="2">Fantasia</option>
                                    <option value="3">Cnpj/Cpf</option>
                                    <option value="4">Insc.Estadual/Rg</option>
                                    <option value="5">Nº Cartão</option>
                                    <option value="6">Telefone(1)</option>
                                    <option value="7">Telefone(2)</option>
							</select>
						</div>
						<div class="col-sm-12 col-md-6 col-lg-6">
							<label for="edconteudopesqcc">Conteúdo da pesquisa:</label>
							<input id="edconteudopesqcc" type="text" class="form-control form-control-sm" v-model="pconteudocc">
						</div>
						<div class="col-6 col-sm-6 col-md-2 col-lg-2">
							<label for="cbqtdreg">Registros:</label>
							<select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistroscc">
								<option value="10">10</option>
								<option value="20">20</option>
								<option value="30">30</option>
								<option value="40">40</option>
								<option value="50">50</option>
								<option value="99999999999">Todos</option>
							</select>
						</div>
						<div class="col-sm-12 col-md-2 col-lg-2">
							<button type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
						</div>
                        <div id="dvlstclientecc" class="col-md-12" style="margin-top: 10px;">
                            <vue-bootstrap4-table
                                    :rows="lstclientescc"
                                    :columns="columns"
                                    :config="config"
                                    :classes="classes">
                                <template slot="empty-results">
                                    <div class="col-md-12 text-center">Sem dados para visualização</div>
                                </template>
                                <!-- ícones de ordenação da table -->
                                <template slot="sort-asc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                </template>
                                <template slot="sort-desc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                </template>
                                <template slot="no-sort-icon">
                                    <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                </template>                                    
                                <!--  -->                                
                                <template slot="id_f" slot-scope="item">
                                    {{ item.row.id }}
                                </template>
                                <template slot="cnpjcpf_f" slot-scope="item">
                                    {{ mtdformatadocumento(item.row.cnpjcpf) }}
                                </template>
                                <template slot="fone1_f" slot-scope="item">
                                    {{ mtdformatafone(item.row.fone1) }}
                                </template>																		
                                <template slot="opcoes" slot-scope="item">
                                    <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdretornoconsulta(item.row.id)" title="Selecionar ítem"><i class="fa fa-hand-pointer-o"></i></button>
                                    <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="" title="Visualizar imagens"><i class="fa fa-picture-o"></i></button>
                                </template>
                            </vue-bootstrap4-table>
                        </div>
                        <div class="col-6 col-md-4">
                            <div class="row" style="padding-right: 15px;">
                                <div class="col-md-12 border rounded" style="margin-left: 15px; padding: 5px 0px 5px 10px;">
                                    <v-pagination
                                            v-model="pagina_atualcc"
                                            :page-count="pqtd_paginascc"
                                            :classes="bootstrapPaginationClasses">
                                    </v-pagination>
                                </div>  
                            </div>                              
                        </div>                            
                        <div class="col-6 col-md-8">
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                    Registros
                                    <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstclientescc.length}}</span>
                                </li>
                            </ul>
                        </div>
					</div>
					<div id="dvimagensconsulta" class="row">
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>
				</div>
			</div>
		</div> 	
	</div>
</template>
<script>
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
	import util from '../utilitarios/util.js'
	export default {
		name: "cmpconsultarclientes",
        components:{
            VueBootstrap4Table,
            vPagination
        },			
		data: function () {
			return {
				lstclientescc  			: [],
				pfiltrocc				: 1,
				pconteudocc 			: '',
				pespecificacaocc		: '',
				pidmarcacc				: null,
                pqtdregistroscc			: 10,
                pqtd_paginascc 			: 1,
                pagina_atualcc 			: 1,
                pqtd_total_registroscc	: 0,				

				idclienteretorno 		: null,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
				},
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },					
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Nome/Razão Social",
                        name: "nome",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Fantasia",
                        name: "fantasia",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "CNPJ/CPF",
                        name: "cnpjcpf",
                        sort: true,
						slot_name: "cnpjcpf_f",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"						
					},					
                    {
                        label: "IE/RG",
                        name: "rginsc",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"						
                    },
                    {
                        label: "Fone(1)",
                        name: "fone1",
                        sort: true,
						slot_name: "fone1_f",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"						
					}					
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
				}
			}
		},
		methods: {
			mtdformatafone(fone){
				return util.formatarfone(fone);
			},
			mtdformatadocumento(doc){
				return util.formatacpfcnpj(doc);
			},
			mtdiniciar_def(){
				let vself = this;
				$('#mdconsultarcliente').on('show.bs.modal', function (e) {
					vself.lstclientescc		= [];
					vself.pfiltrocc			= 1;
					vself.pconteudocc 		= '';
				});				
				$('#mdconsultarcliente').on('shown.bs.modal', function (e) {
					$('#edconteudopesqcc').focus();
				});
				$('#mdconsultarcliente').on('hidden.bs.modal', function (e) {
					vself.mtdfecharconsulta();
				});								
			},
			mtdretornoconsulta(idclienteret){
				let payload = {
					idcliente    : idclienteret			
				};
				this.$store.commit('CLIENTE_RETORNO_CHANGE',payload);					
				this.mtdfecharconsulta();
			},
			mtdfecharconsulta(){
				let payload = {
					abrirtela    : false			
				};
				this.$store.commit('CONSULTA_CLIENTE_CHANGE',payload);								
			},
            mtdfiltropesquisa(){
				let rfiltrocc = '';							

                switch (parseInt(this.pfiltrocc)) {
                    case 0:
                        rfiltrocc = this.pconteudocc === '' ? '' : ' and c.id='+this.pconteudocc;
                        break;
                    case 1:
                        rfiltrocc = this.pconteudocc === '' ? '' : ' and upper(c.nome) like upper(\''+this.pconteudocc+'%\')';
                        break;
                    case 2:
                        rfiltrocc = this.pconteudocc === '' ? '' : ' and upper(c.fantasia) like upper(\''+this.pconteudocc+'%\')';
                        break;  
                    case 3:
                        rfiltrocc = this.pconteudocc === '' ? '' : ' and upper(c.cnpjcpf) like upper(\''+this.pconteudocc+'%\')';
                        break; 
                    case 4:
                        rfiltrocc = this.pconteudocc === '' ? '' : ' and upper(c.rginsc) like upper(\''+this.pconteudocc+'%\')';
                        break;     
                    case 5:
                        rfiltrocc = this.pconteudocc === '' ? '' : ' and upper(c.nrcartao) like upper(\''+this.pconteudocc+'%\')';
                        break;  
                    case 6:
                        rfiltrocc = this.pconteudocc === '' ? '' : ' and upper(c.fone1) like upper(\''+this.pconteudocc+'%\')';
                        break; 
                    case 7:
                        rfiltrocc = this.pconteudocc === '' ? '' : ' and upper(c.fone2) like upper(\''+this.pconteudocc+'%\')';
                        break;                                                                                                                                            
                }               

				rfiltrocc = rfiltrocc + ' and c.ativo=0';				
				
                return rfiltrocc;
			},
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atualcc = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registroscc 	= parseInt(response.data.qtdregistros);
                    let qtdpg                  		= Math.ceil(vself.pqtd_total_registroscc / vself.pqtdregistroscc);
                    vself.pqtd_paginascc       		= qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaclientes(1);
                }).catch(function (response) {
                    this.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
			},
            mtdcarregaclientes(ipagina){
				var vself       = this;
				let loader      = this.$loading.show();
				let filtro      = vself.mtdfiltropesquisa();
				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgclientes+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',               valor : 'listagem'},
					{parametro: 'filtro',           valor : filtro},
					{parametro: 'limit',            valor : vself.pqtdregistroscc},
					{parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistroscc)},
				];
				let retorno             = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
				retorno.then(function (response) {
					vself.lstclientescc = response.data;
					loader.hide();
				}).catch(function (response) {
					vself.lstclientescc = [];
					loader.hide();
				});
            },						
		},
        mounted: function () {       
			this.mtdiniciar_def();
        },
        computed: {
            abrirtela(){
                return this.$store.state.consultaclientes.abrirtela;                
            }						
        },
        watch:{
			abrirtela(val){
				if (val){
					$('#mdconsultarcliente').modal('show');
				}else{					
					$('#mdconsultarcliente').modal('hide');
				}
			},
            pagina_atualcc(val){
                this.mtdcarregaclientes(val);
            }			
        }
	}
</script>
<style>
	#dvlstclientecc thead th {
		color: #cccccc!important;
		background-color: #343a40!important;
		border-color: #454d55!important;
		font-weight: 100!important;
    }
    #mdconsultarcliente{
        z-index: 2000!important;
    }
</style>